import { BabyPaciffer } from 'assets/baby-paciffer'
import { ReactComponent as HealthLogo } from 'assets/icons/health-logo.svg'
import LactationLogo from 'assets/LactationLogo'

import { ReactComponent as NotLactationLogo } from 'assets/not_lactation_logo.svg'
import { GroupCowStatus } from 'models/IGroup'
import { COLORS } from 'styles/colors'
import InfoChipItem from 'ui/InfoChipItem'

type IProps = {
	status: GroupCowStatus
}

export const StatusGroupLabels = (props: IProps) => {
	const { status } = props
	const statusColors = {
		[GroupCowStatus.Milk]: COLORS.blue,
		[GroupCowStatus.Dry]: COLORS.secondary,
		[GroupCowStatus.Dry_1]: COLORS.secondary,
		[GroupCowStatus.Dry_2]: COLORS.secondary,
		[GroupCowStatus.Birthplace]: COLORS.pinkText,
		[GroupCowStatus.Infirmary]: COLORS.error,
	}
	const statusBg = {
		[GroupCowStatus.Milk]: COLORS.blueBg,
		[GroupCowStatus.Dry]: COLORS.background,
		[GroupCowStatus.Dry_1]: COLORS.background,
		[GroupCowStatus.Dry_2]: COLORS.background,
		[GroupCowStatus.Birthplace]: COLORS.pinkBg,
		[GroupCowStatus.Infirmary]: COLORS.error10,
	}

	const bgColor = statusBg[status]
	const labelColor = statusColors[status]
	const statusIcon = {
		[GroupCowStatus.Milk]: <LactationLogo width={'16px'} color={labelColor} />,
		[GroupCowStatus.Dry]: <NotLactationLogo width={'16px'} fill={labelColor} />,
		[GroupCowStatus.Dry_1]: (
			<NotLactationLogo width={'16px'} fill={labelColor} />
		),
		[GroupCowStatus.Dry_2]: (
			<NotLactationLogo width={'16px'} fill={labelColor} />
		),
		[GroupCowStatus.Birthplace]: <BabyPaciffer />,
		[GroupCowStatus.Infirmary]: (
			<HealthLogo width={'16px'} fill={labelColor} stroke={labelColor} />
		),
	}

	const icon = statusIcon[status]

	return (
		<InfoChipItem
			bgColor={bgColor}
			label={status}
			labelColor={labelColor}
			icon={icon}
		/>
	)
}
